import { render, staticRenderFns } from "./AddProductModelComponent.vue?vue&type=template&id=0a83b1ce&scoped=true"
import script from "./AddProductModelComponent.vue?vue&type=script&lang=js"
export * from "./AddProductModelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83b1ce",
  null
  
)

export default component.exports